import { cn } from '../../utils/cn';

/**
 * Consistent page header with title, description, and actions slot.
 *
 * @param {Object} props
 * @param {string} props.title - Page title (h1)
 * @param {string} [props.description] - Page description
 * @param {React.ReactNode} [props.actions] - Action buttons slot
 * @param {React.ReactNode} [props.breadcrumb] - Breadcrumb slot
 * @param {string} [props.className] - Additional classes
 */
export function PageHeader({
  title,
  description,
  actions,
  breadcrumb,
  className,
  ...props
}) {
  return (
    <div className={cn('mb-6', className)} {...props}>
      {breadcrumb && (
        <div className="mb-2">
          {breadcrumb}
        </div>
      )}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-2xl sm:text-3xl font-semibold text-neutral-900">
            {title}
          </h1>
          {description && (
            <p className="mt-1 text-sm text-neutral-500">
              {description}
            </p>
          )}
        </div>
        {actions && (
          <div className="flex items-center gap-3 flex-shrink-0">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}
